export const modalStyles = {
  right: 0,
  left: 'auto',
  top: 0,
  maxHeight: '100%',
  height: '100%',
  maxWidth: '300px'
};

export const styleTextBold = {
  fontWeight: 'bold'
}

export const styleInputField = {
  margin: '10px 0'
}

export const stylePage = {
  backgroundColor: '#fff',
  paddingBottom: '20%',
  paddingTop: '30px'
}

export const listStyle = {
  listStyleType: 'circle', 
  paddingLeft: '20px'
}

export const ErrorStyles = {
  color: 'red',
  marginBottom: 0
}
